import { gql } from "graphql-tag";

import { getMemberBenefits } from "~/slices/MemberBenefits/fragment";
import { getShopByOffer } from "~/slices/ShopByOffer/fragment";
import { getProductCatalogueV2 } from "~/slices/ProductCatalogueV2/fragment";
import { getTextBlockV2 } from "~/slices/TextBlockV2/fragment";
import { getButtonGalleryV2 } from "~/slices/ButtonGalleryV2/fragment";
import { getMediaGridV2 } from "~/slices/MediaGridV2/fragment";
import { getShopByOfferV2 } from "~/slices/ShopByOfferV2/fragment";
import { getImageSectionV2 } from "~/slices/ImageSectionV2/fragment";
import { getSeoFields, getMetaFields } from "~/mixins/seoMixin";

const PAGE_TYPE = "Campaign_landing_page1";
const CAMPAIGN_QUERY = gql`
  query campaign_landing_page1($uid: String!, $lazy: Boolean!, $lang: String = "en-in") {
    ${PAGE_TYPE}: campaign_landing_page1(uid: $uid, lang: $lang) {
      title
      display_banner
      optional_bg_image
      campaign_sale_link {
        ... on Campaign_sale1 {
          _meta {
            uid
          }
        }
      }
      ...${PAGE_TYPE}SEOFields
      ...${PAGE_TYPE}MetaFields
      slices: body {
        __typename
        ...${PAGE_TYPE}_Member_benefits
        ...${PAGE_TYPE}_Shop_by_offer
        ...${PAGE_TYPE}_product_catalogue_v2
        ...${PAGE_TYPE}_Text_block_v2
        ...${PAGE_TYPE}_Button_gallery_v2
        ...${PAGE_TYPE}_Media_grid_v2
        ...${PAGE_TYPE}_shop_by_offer_v2
        ...${PAGE_TYPE}_image_section_v2
      }
    }
  }
  ${getMemberBenefits(PAGE_TYPE)}
  ${getShopByOffer(PAGE_TYPE)}
  ${getProductCatalogueV2(PAGE_TYPE)}
  ${getSeoFields(PAGE_TYPE)}
  ${getMetaFields(PAGE_TYPE)}
  ${getTextBlockV2(PAGE_TYPE)}
  ${getButtonGalleryV2(PAGE_TYPE)}
  ${getMediaGridV2(PAGE_TYPE)}
  ${getShopByOfferV2(PAGE_TYPE, "Body")}
  ${getImageSectionV2(PAGE_TYPE)}`;

export { PAGE_TYPE, CAMPAIGN_QUERY };
